import React from 'react';
import DummyPage from '../components/DummyPage';
import PageContainer from '../containers/PageContainer';

const SupportPage = () => {
  return (
    <PageContainer>
      <DummyPage title="Support" />
    </PageContainer>
  );
};

export default SupportPage;
